// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1FpH7","content":"ManualTimeModal_content__xwqNI"};